"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultStyles = {
  display: "flex",
  alignItems: "center",
  padding: "10px 18px",
  borderTop: "1px solid #ccc",
  marginTop: "0"
};

exports.default = function (_ref) {
  var style = _ref.style,
      children = _ref.children;

  var styles = _extends({}, defaultStyles, style);

  return _react2.default.createElement("div", {
    className: "card__footer",
    style: styles
  }, children);
};